import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import {
  TrustArc,
  TrustArcOptions,
  TrustArcThemeOptions,
} from '@trustarc/primeng-theme';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DialogService } from 'primeng/dynamicdialog';
import { ToastModule } from 'primeng/toast';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './auth-interceptor';
import { ApiService } from './modules/aaacommon/services/api.service';
import { TranslationLoaderService } from './modules/aaacommon/services/translation-loader.service';
import { NoAccessComponent } from './no-access/no-access.component';

const primeModules = [ToastModule, ConfirmDialogModule, DialogModule];

@NgModule({
  declarations: [AppComponent, NoAccessComponent],
  exports: [],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ToastrModule.forRoot({ positionClass: 'toast-top-right' }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationLoaderService,
        deps: [ApiService],
      },
    }),
    ModalModule.forRoot(),
    ...primeModules,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    providePrimeNG({
      ...TrustArcOptions,
      theme: {
        preset: definePreset(Aura, TrustArc),
        options: TrustArcThemeOptions,
      },
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    MessageService,
    ConfirmationService,
    DialogService,
  ],
})
export class AppModule {
  constructor() {}
}
